import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getCompanySettings = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetCompanySetting}?companyCode=${companyCode}`
  );
  return data;
};

const getUserCompanies = async ({ userId }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserCompanyList}?UserId=${userId}`
  );
  return data;
};

const updateCompanySetting = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateCompanySetting,
    input
  );
  return data;
};

export const useGetCompanySettingQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetCompanySetting],
    queryFn: () => getCompanySettings(companyCode),
    refetchOnWindowFocus: false,
  });
};

export const useGetUserCompaniesQuery = (input) => {
  // return useQuery({
  //   queryKey: [Api_EndPoints.GetUserCompanyList],
  //   // queryKey: `${[Api_EndPoints.GetUserCompanyList]}-${new Date().getTime()}`,
  //   queryFn: () => getUserCompanies(input),
  //   refetchOnWindowFocus: false,
  // });
  return useQuery({
    queryKey: [Api_EndPoints.GetUserCompanyList, input],
    queryFn: () => getUserCompanies(input),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: 1,
  });
};

export const useUpdateCompanySettingMutation = () => {
  return useMutation({
    mutationFn: updateCompanySetting,
  });
};
